import { InsuredTabFormValues } from "./types";
import { PolicyholderType } from "@covertree/new-business-graphql";

/** Empty Insured Info form — the static defaults before a policy is seeded. */
export const EMPTY_INSURED_TAB_FORM_VALUES: InsuredTabFormValues = {
  name: "",
  endorsementEffectiveDate: null,
  reason: "",
  type: PolicyholderType.Person,
  firstName: "",
  middleName: "",
  lastName: "",
  insuredDateOfBirth: "",
  orgName: "",
  orgType: undefined,
  repRelationToOrg: undefined,
  describeOrgType: "",
  additionalInsured: undefined,
  propertyStreetAddress: "",
  propertyUnitNumber: "",
  propertyCity: "",
  propertyState: "",
  propertyZipCode: "",
  additionalInterests: [],
  manufacturer: undefined,
  homeType: undefined,
  makeCustom: undefined,
  modelHome: undefined,
  modelYear: undefined,
  totalSquareFootage: undefined,
  homeWidth: undefined,
  homeLength: undefined,
  location: undefined,
  communityName: undefined,
  roofShape: undefined,
  roofYearYyyy: undefined,
  homeHudNumber: undefined,
  skirtingType: undefined,
  homeFixtures: undefined,
};
